import { render, staticRenderFns } from "./VideoDetail.vue?vue&type=template&id=3239ed6c&scoped=true&"
import script from "./VideoDetail.vue?vue&type=script&lang=js&"
export * from "./VideoDetail.vue?vue&type=script&lang=js&"
import style0 from "./VideoDetail.vue?vue&type=style&index=0&id=3239ed6c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3239ed6c",
  null
  
)

export default component.exports